// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label {
  font-size: 14px;
  margin-right: 10px;
  position: relative;
  top: 0px;
}
.label .required-asterisk {
  color: red;
}

.dropdown {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  border: 1px solid #b3b3b3;
  border-radius: 5px;
  padding: 0.65rem;
  margin-top: 0.25rem;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 5px;
}
.dropdown .value {
  cursor: pointer;
  position: relative;
  top: -3px;
  font-size: 14px;
}
.dropdown svg {
  width: 20px;
  height: 20px;
  font-size: 20px;
  position: relative;
  left: 5px;
  top: -3px;
}

.error {
  border: 1px solid #cc0000;
}

.menu {
  position: absolute;
  z-index: 2000;
  background: white;
  color: #333333;
  text-align: center;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 4px 0px;
  align-items: center;
  max-height: 170px;
  overflow: auto;
}
.menu.up {
  bottom: 28px;
}
.menu.down {
  top: 40px;
}
.menu span {
  white-space: nowrap;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 15px 20px;
  min-height: 20px;
}
.menu span:hover {
  background: rgba(94, 159, 105, 0.15);
}

.dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
}
.dropdown-container.disabled {
  color: gray;
  cursor: not-allowed;
}

@media screen and (max-width: 576px) {
  .menu span.menu-option {
    font-size: 14px;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/dropdown/dropdown.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AACF;AAAE;EACE,UAAA;AAEJ;;AACA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AACF;AAAE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;AAEJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AAEJ;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,8CAAA;EACA,mBAAA;EAOA,iBAAA;EACA,cAAA;AALF;AAFE;EACE,YAAA;AAIJ;AAFE;EACE,SAAA;AAIJ;AAAE;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AADI;EACE,oCAAA;AAGN;;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAEF;AADE;EACE,WAAA;EACA,mBAAA;AAGJ;;AACA;EACE;IACE,eAAA;EAEF;AACF;AACA,g3GAAg3G","sourcesContent":[".label {\n  font-size: 14px;\n  margin-right: 10px;\n  position: relative;\n  top: 0px;\n  .required-asterisk {\n    color: red;\n  }\n}\n.dropdown {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  border: 1px solid #b3b3b3;\n  border-radius: 5px;\n  //padding: 8px 15px 3px 15px;\n  padding: .65rem;\n  margin-top: 0.25rem;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 5px;\n  .value {\n    cursor: pointer;\n    position: relative;\n    top: -3px;\n    font-size: 14px;\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n    font-size: 20px;\n    position: relative;\n    left: 5px;\n    top: -3px;\n  }\n}\n\n.error {\n  border: 1px solid #cc0000;\n}\n\n.menu {\n  position: absolute;\n  z-index: 2000;\n  background: white;\n  color: #333333;\n  text-align: center;\n  border-radius: 4px;\n  box-shadow: rgba(0, 0, 0, .5) 0px 2px 4px 0px;\n  align-items: center;\n  &.up {\n    bottom: 28px;\n  }\n  &.down {\n    top: 40px;\n  }\n  max-height: 170px;\n  overflow: auto;\n  span {\n    white-space: nowrap;\n    font-size: 14px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    padding: 15px 20px;\n    min-height: 20px;\n    &:hover {\n      background: rgba(94, 159, 105, .15);\n    }\n  }\n}\n.dropdown-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  &.disabled {\n    color: gray;\n    cursor: not-allowed;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .menu span.menu-option {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
